module.exports = __webpack_public_path__ + "img/jingsai.237372f.svg";